import { createSelector } from "reselect";

import Immutable from "seamless-immutable";

export const selectApp = (state) => state;

export const getUserSession = (state) => {
    return state.userSession
  };
 
export const selectAllSubjects=(state)=>createSelector(
    selectApp,
    (appState) => appState.allSubjects
)